<lib-mini-progress-spinner *ngIf="filesLoading"></lib-mini-progress-spinner>

<ng-container *ngIf="!filesLoading">

  <div class="file-names">
    <div class="file" *ngFor="let quoteFile of quoteFiles;">
      <div class="file-name">
        <span (click)="openFile(quoteFile)">{{quoteFile?.name}}</span>
      </div>
    </div>
  </div>


  <mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
  </mat-progress-bar>


  <p-fileUpload mode="advanced" name="files" #filesForm [customUpload]="true" (onProgress)="onProgress($event)"
                (uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
                chooseLabel="Upload">
    <ng-template pTemplate="content">
      <div class="attachments-block" (click)="chooseFile()">
        <i class="pi pi-download" style="font-size: 130%; margin-bottom: 0.4em;"></i>
        <div>
          <span class="add-attachment">Attach your quote</span>
          <span class="drop-here"> or drag it here.</span>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>

</ng-container>
